import { updateVideoStateNextVideoIsBinge } from 'app/actions/videoPage';
import { UserContext } from 'app/context/UserContext';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { setTTFFStart } from '../../actions/videoPlayer';

export type OpenModalProps = {
    videoId: string;
    videoUrl: string;
    position?: number;
    isWatchingBreakingNews?: boolean;
    extraQuery?: {
        [id: string]: string | number | boolean;
    };
    children: (handleOnClick: () => void) => React.ReactNode;
};

const OpenModal: React.FC<OpenModalProps> = ({
    videoId,
    videoUrl,
    position,
    extraQuery,
    children,
    isWatchingBreakingNews = false,
}) => {
    const query = { modalId: videoId } as any;
    const visibleId = { id: videoId } as any;
    const router = useRouter();
    const dispatch = useDispatch();
    const { setIsWatchingBreakingNews } = useContext(UserContext);
    let visiblePosition;

    if (position) {
        query.position = position;
        visiblePosition = { position };
    }

    if (!router.query.modalId) {
        query.delayUnmount = true;
    }

    const handleOnClick = () => {
        dispatch(setTTFFStart(Date.now()));
        dispatch(updateVideoStateNextVideoIsBinge(false));
        setIsWatchingBreakingNews(isWatchingBreakingNews);
    };

    const href = {
        pathname: '/[...slug]',
        query: { ...query, ...extraQuery },
    } as any;

    return (
        <Link
            href={href}
            as={{
                pathname: videoUrl,
                query: { ...visibleId, ...visiblePosition, ...extraQuery },
            }}
            scroll={false}
            passHref
            replace={Boolean(router.query.modalId)}
        >
            {children(handleOnClick)}
        </Link>
    );
};

export default OpenModal;
